// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__RxKbz","x":"styles_x__3Ja3p","o":"styles_o__1b6VY"};